import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import IconPlay from './svg/IconPlay';
import IconPause from './svg/IconPause';

function ConnectedPlayButtonV2({ onPlay, onPause, isCurrentPlayAutomix }) {
  return (
    <div className={`align`} onClick={isCurrentPlayAutomix ? onPause : onPlay} >
      { isCurrentPlayAutomix 
        ? <IconPause size={40} className={`cf-icon-play-pause`} color={Config.BRAND_PRIMARY} /> 
        : <IconPlay size={40} className={`cf-icon-play-pause`} color={Config.BRAND_PRIMARY} /> 
      }
    </div>
  )
}

ConnectedPlayButtonV2.propTypes = {
  onPlay: PropTypes.func.isRequired,
  onPause: PropTypes.func.isRequired,
  isCurrentPlayAutomix: PropTypes.bool,
}

const PlayButtonV2 = connect(
  state => ({
    isCurrentPlayAutomix: state.isCurrentPlayAutomix,
  })
)(ConnectedPlayButtonV2);

export default PlayButtonV2;
